import { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import * as React from "react";
import classNames from "classnames";
import { CSSTransition } from "react-transition-group";
import AdviserSiteTagManager, {
    AdviserSiteTagManagerEvent,
} from "../../../applications/Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import useApplicationRegistrationCookiePopup from "../../../applications/Shared/Cookies/ChoicesCookie/useApplicationRegistrationCookiePopup.hook";

export interface ITableFilterDropdown {
    label?: string;
    labelSrOnly?: string;
    cssWrapper?: string;
    children?: React.ReactChild | React.ReactChildren;
    onOpen?: (func) => void;
    title?: string;
    event?: AdviserSiteTagManagerEvent;
}

const TableFilterDropdown = (props: ITableFilterDropdown, ref: any) => {
    const wrapperRef = useRef(null);
    const { label, cssWrapper } = props;
    const [isOpen, setIsOpen] = useState(false);

    useImperativeHandle(ref, () => ({
        close: () => {
            ToggleDropdown(true);
        },
    }));

    const handleClickOutside = (event: any) => {
        if (wrapperRef && !wrapperRef.current.contains(event.target)) {setIsOpen(false);}
    };

    const ToggleDropdown = (isOpen) => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        if (props.onOpen) {props.onOpen(ToggleDropdown);}
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const { addEvent } = new AdviserSiteTagManager();

    const cssClass = classNames("table-filter ", cssWrapper);
    return (
        <div className={cssClass} ref={wrapperRef}>
            <button
                className="trigger"
                onClick={() => {
                    if (props.event) {addEvent(props.event);}
                    ToggleDropdown(isOpen);
                }}
                aria-expanded={isOpen}
                title={props.title}
            >
                <span className="text">{label}</span>
                {props.labelSrOnly ? <span className="sr-only">{props.labelSrOnly}</span> : null}
                <span className="icon" aria-hidden={true} />
            </button>

            <CSSTransition
                unmountOnExit
                classNames="filter-dropdown-list filter-dropdown-csstrans-enter-done"
                in={isOpen}
                timeout={300}
            >
                {(isOpen) => (
                    <div aria-hidden={!isOpen}>
                        <span aria-hidden={true} className="filter-dropdown-list-sh1" />
                        <span aria-hidden={true} className="filter-dropdown-list-sh2" />
                        <div className="filter-dropdown-list-panel">
                            <div className="filter-dropdown-list-inner">{props.children}</div>
                        </div>
                    </div>
                )}
            </CSSTransition>
        </div>
    );
};

export default forwardRef(TableFilterDropdown);
